require('../../modules/es6.symbol');
module.exports = require('../../modules/_core').Symbol['for'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/symbol/for.js
 ** module id = 229
 ** module chunks = 0
 **/